/**
 * Calculates the number of pages needed for pagination based on total items and items per page
 * @param totalItems - The total number of items (can be undefined)
 * @param itemsPerPage - Number of items to display per page
 * @returns Number of pages needed (minimum 1)
 */
export function calculateTotalPages(totalItems: number | undefined, itemsPerPage: number): number {
  const safeTotal = totalItems ?? 0
  return Math.max(1, Math.ceil(safeTotal / itemsPerPage))
}

/**
 * Generates an array of page numbers for static params generation
 * @param totalItems - The total number of items (can be undefined)
 * @param itemsPerPage - Number of items to display per page
 * @returns Array of page numbers starting from 1
 */
export function generatePageNumbers(
  totalItems: number | undefined,
  itemsPerPage: number,
): number[] {
  const totalPages = calculateTotalPages(totalItems, itemsPerPage)
  return Array.from({ length: totalPages }, (_, i) => i + 1)
}
